import { removeTime } from '@/utils/date'

export const checkDateRangeTo = {
  getMessage: (field, args) => {
    if (args.length > 0) {
      return 'Must be a later From Date'
    }
  },
  validate: (value, args) => {
    if (value) {
      if (args.length > 0) {
        return removeTime(value) >= removeTime(args)
      } else {
        return true
      }
    } else {
      return true
    }
  }
}

export const checkDateRangeFrom = {
  getMessage: (field, args) => {
    if (args.length > 0) {
      return 'From Date cannot be later than To Date'
    }
  },
  validate: (value, args) => {
    if (value) {
      if (args.length > 0) {
        return removeTime(value) <= removeTime(args)
      } else {
        return true
      }
    } else {
      return true
    }
  }
}
